const API_URL = process.env.REACT_APP_API_URL || "";

// Fetches a one-time NHCX auto-login URL from Smart Clinic's own backend (which mints a
// short-lived hospital-signed token) and opens the NHCX Insurance Claim dashboard already
// signed in. Mirrors the meds-portal SSO pattern in medsPortalAuth.js.
export async function openNhcxSso() {
  const token = localStorage.getItem("auth_token");
  const tenantId = localStorage.getItem("tenantId");
  if (!token) throw new Error("Not logged in.");

  const res = await fetch(`${API_URL}nhcx/sso-redirect-url`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      tenantId: tenantId || "",
    },
  });
  const data = await res.json();

  if (!res.ok) throw new Error(data?.error || data?.message || "Failed to reach NHCX.");

  const redirectUrl = data?.data?.redirectUrl;
  if (!redirectUrl) throw new Error("Missing redirect URL from NHCX SSO API.");

  // Named target (not "_blank") so a click while the NHCX tab is still open reuses/focuses
  // that same tab with the fresh token, instead of stacking up a new tab every time.
  window.open(redirectUrl, "nhcx-sso-tab");

  return { redirectUrl };
}
